import { useQuery } from '@tanstack/react-query'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { QUERY_DATA, getResellerSlugFromOrderId } from 'src/service'
import { getConfig } from 'src/helpers'
import { LoadingFull } from '../../atoms'

const getResellerFromLocalStorage = () => localStorage.getItem('re')

export const RedirectToNewCustomerAreaRoutes = () => {
  const { orderId } = useParams()
  const { pathname } = useLocation()
  const { genericUser } = getConfig()

  const resellerFromLocalStorage = getResellerFromLocalStorage()

  const { data, isFetching } = useQuery(
    [QUERY_DATA.RESELLER_FROM_ORDER_ID],
    () => getResellerSlugFromOrderId(orderId),
    {
      retry: false,
      enabled: Boolean(orderId && !resellerFromLocalStorage),
    },
  )

  const reseller = resellerFromLocalStorage || data?.resellerSlug || genericUser.catalogSlug

  return isFetching ? <LoadingFull /> : <Navigate to={`/${reseller}${pathname}`} />
}
